import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import { Dataset } from './Dataset';
import DatasetDialog from './DatasetDialog';
import APIRequest from 'system/APIRequest';
import { enqueueSnackbar } from 'notistack';
import { socialDatasetId } from 'system/query/Query';
import { permissionTest } from 'system/InfegyUser';

export interface DatasetSelectionButtonProps {
  selectedDatasetId: string;
  setSelectedDatasetId: (datasetId: string) => void;

  selectDefaultDataset?: boolean;

  size?: "small" | "medium" | "large";
}

export default function DatasetSelectionButton(props: DatasetSelectionButtonProps): JSX.Element {
  const { i18n } = useTranslation();

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const [selectedDataset, setSelectedDataset] = useState<Dataset | undefined>(undefined);

  // Load the selected dataset from the selectedDatasetId
  useEffect(() => {
    if (!props.selectedDatasetId) {
      if (props.selectDefaultDataset) {
        if (permissionTest("social_data")) {
          // Load the social dataset as the default dataset if the user has permission
          props.setSelectedDatasetId(socialDatasetId);
        } else {
          APIRequest('obj/dataset').then((response: any) => {
            if (response.output && response.output.length > 0) {
              props.setSelectedDatasetId(response.output[0].id);
            } else {
              setSelectedDataset(undefined);
            }
          }).catch((reason: APIError) => {
            enqueueSnackbar(i18n.t('resources.datasets.dataset-load-error'), {variant: 'error'});
          });
        }
      } else {
        setSelectedDataset(undefined);
      }
      return;
    }
    APIRequest(`obj/dataset/${props.selectedDatasetId}`).then((response: any) => {
      setSelectedDataset(response.output);
    }).catch((reason: APIError) => {
      enqueueSnackbar(i18n.t('resources.datasets.dataset-load-error'), {variant: 'error'});
    });
  }, [props.selectedDatasetId]);

  return (
  <>
    <Button
      variant={selectedDataset ? "outlined" : "contained"}
      onClick={() => setDialogOpen(true)}
      size={props.size || "medium"}
      endIcon={<EditIcon />}>
      {selectedDataset ? selectedDataset.name : i18n.t('resources.datasets.select-dataset')}
    </Button>
    <DatasetDialog
      open={dialogOpen}
      onClose={() => setDialogOpen(false)}
      onSubmit={(dataset: Dataset | undefined) => {
        if (dataset === undefined) {
          return;
        }
        props.setSelectedDatasetId(dataset.id);
        setDialogOpen(false);
      }}/>
  </>
  );
}